export const MAIN_WRAP = 'main-wrap';

export const getHeader = () => document.getElementsByTagName('header')[0];
export const getMain = () => document.getElementsByTagName('main')[0];
export const getMainWrap = () => document.getElementById(MAIN_WRAP);

type GetLineHeightFromFont = (font: { lineHeight: number; fontSize: string }) => number;
export const getLineHeightFromFont: GetLineHeightFromFont = font =>
    font.lineHeight * parseFloat(font.fontSize) * 10;
